"use strict";

exports.__esModule = true;
exports.WorkdaySelector = WorkdaySelector;
var _datetime = require("@blueprintjs/datetime");
var _react = _interopRequireDefault(require("react"));
var _WorkdayRangeSelector = require("./WorkdayRangeSelector");
var _WorkdaySelectorPopover = require("./WorkdaySelectorPopover");
var _excluded = ["multiple"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Allows a user to select a workday or range of workdays from a calendar.
 */
function WorkdaySelector(_ref) {
  var multiple = _ref.multiple,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (multiple) {
    return /*#__PURE__*/_react["default"].createElement(_WorkdayRangeSelector.WorkdayRangeSelector, props);
  }
  return /*#__PURE__*/_react["default"].createElement(_WorkdaySelectorPopover.WorkdaySelectorPopover, props);
}